import { Playground, Props } from 'docz';
import { ResourceDispatch } from "../../../../../src/services/resource/resource_defaults";
import DataTableHeader from "../../../../../src/templates/DataTableHeader/index";
import "../../../../../src/theme/styles/index.scss";
import * as React from 'react';
export default {
  Playground,
  Props,
  ResourceDispatch,
  DataTableHeader,
  React
};